import { z } from 'zod'

import { geocodeDataSchema } from './geocode'

export const streamOverviewSchema = z.object({
  reverseGeocodeData: geocodeDataSchema.optional(),
  acres: z.number(),
  task: z.string(),
  coordinates: z.object({
    lat: z.number(),
    lon: z.number()
  }),
  dashboardDbm: z.number(),
  defaultLayer: z.object({
    applicationId: z.string(),
    applicationName: z.string(),
    layerId: z.string(),
    layerName: z.string(),
    layerKey: z.string(),
    satelliteUrl: z.string().optional(),
    thumbnailKey: z.string().optional()
  })
})
